import * as React from "react"
import { Box, Typography } from "@mui/material"

import ChipBlock from "./ChipBlock"


export default function ConditionsBlock({ conditions }) {
	return Object.entries(conditions)
		.map(([label, value]) => [label, Array.isArray(value) ? value : [value]])
		.filter(([, items]) => items.length > 0)
		.map(([label, items]) => <Box key={label} sx={{ marginBottom: '0.5rem' }}>
			<Typography variant="subtitle2" sx={{ textAlign: 'center' }}>
				{label}
			</Typography>
			<ChipBlock listElements={items} />
		</Box>)
}
